import Joi from 'joi'

const messages = {
  name: {
    required: 'Nome da tabela é obrigatório',
    max: 'Permitido no máximo 60 caracteres'
  }
}

export const priceListSchema = Joi.object({
  id: Joi.string().uuid({ version: ['uuidv4'] }),
  name: Joi.string().max(60).trim().required().messages({
    'any.required': messages.name.required,
    'string.empty': messages.name.required,
    'string.max': messages.name.max
  })
})
